import { createGlobalStyle } from 'styled-components';
import { BaseCss } from './base-css';
import { CssReset } from './css-reset';

// Global styles - should be imported as base css for every app
// See: https://styled-components.com/docs/api#createglobalstyle
export const GlobalStyles = createGlobalStyle`
  ${CssReset}
  ${BaseCss}
`;
